import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { TinyUser } from "@/types/TinyUser";

class UserSearchService {
  path: string;

  constructor(path: string) {
    this.path = path;
  }

  searchShareSuggestions(term: string, tenantExternalId: string): Promise<ApiResponseV2<TinyUser[]>> {
    return HttpClientV2.get(`${this.path}/share/suggestions?term=${term}&tenantExternalId=${tenantExternalId}`);
  }
}

export default new UserSearchService("/api/user-search");
